module.exports = __webpack_public_path__ + "assets/img/202110-4.4f0994a3.png";